function requestAPI(id, data, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}transaction-sgh/edit-order/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(data)
  }).then((res) => res.json())
}

export default function actionEditOrderTransaction(id, data) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'EDIT_ORDER_TRANSACTION_SGH_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(id, data, token)
      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'EDIT_ORDER_TRANSACTION_SGH_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'EDIT_ORDER_TRANSACTION_SGH_FAILURE',
    error: error
  })
}
